<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Perfect-Center"><br/></p>
<p class="Perfect-Center">“No trooper, no special forces operative wants to sit behind a desk. We joined up to kick some doors down.” Ant Middleton</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quote2.vue?d49b3586